import { FixedAssetsScheduleFormMovement } from './fixed-assets-schedule-form-movement.interface';
import { IFixedAssetsScheduleReference } from './fixed-assets-schedule-reference.interface';

export interface FixedAssetsScheduleFormData {
    reference: IFixedAssetsScheduleReference;
    costsLabel: string;
    depreciationLabel: string;
    valueAppreciationLabel: string;
    movements: FixedAssetsScheduleFormMovement[];
}
